import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white p-4">
      <h1 className="text-6xl font-bold text-gray-800 mb-4">404</h1>
      <h2 className="text-2xl md:text-3xl text-gray-600 mb-6">
        {t('common.notFoundTitle', 'Sahifa topilmadi')}
      </h2>
      <p className="text-gray-500 mb-8 text-center max-w-md">
        {t(
          'common.notFoundMessage',
          'Kechirasiz, so‘ralgan manzil mavjud emas yoki ko‘chirilgan bo‘lishi mumkin.'
        )}
      </p>
      <Link
        to="/"
        className="bg-etmgreen text-white px-6 py-3 rounded-lg hover:bg-green-600 transition font-medium"
      >
        {t('common.backHome', 'Bosh sahifaga qaytish')}
      </Link>
    </div>
  );
};

export default NotFound;
